import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography, Backdrop } from '@mui/material';

const LoadingSpinner = ({ open, message }) => {
  const { t } = useTranslation();
  
  // message가 없으면 기본 번역 사용
  const displayMessage = message || t('common.defaultProcessing');
  
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
      open={open}
    >
      <CircularProgress color="inherit" size={60} />
      <Typography variant="h6" sx={{ color: '#fff', fontWeight: 500 }}>
        {displayMessage}
      </Typography>
    </Backdrop>
  );
};

export default LoadingSpinner; 